import apiInstance from "./axios";
import {
  master_data_banks,
  master_data_golf_courses,
  master_data_controller,
  master_data_lucky_draw,
} from "utils/services/api/schemas";
import liff from "@line/liff";

const masterDataApi = {
  getMasterDataBanks: async () => {
    const idToken = liff.getIDToken();
    const response = await apiInstance.get(master_data_banks, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    return response;
  },
  getMasterDataGolfCourses: async () => {
    const idToken = liff.getIDToken();
    const response = await apiInstance.get(master_data_golf_courses, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    return response;
  },
  getMasterDataController: async () => {
    const idToken = liff.getIDToken();
    const response = await apiInstance.get(master_data_controller, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    return response;
  },
  getListLuckydraw: async () => {
    const response = await apiInstance.get(`${master_data_lucky_draw}`);
    return response;
  },
};

export default masterDataApi;
